import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { ActionMenu, Button, Dropdown, GenericTable, Input, tCell, toastMessage } from "../utils";
import { buttonClasses } from "../utils/theme";
import { useCheckpoints, useDynamicModuleEntries, useDynamicModules, useOrgs, usePlant, useProductCategories, useProducts, useRule, useSuppliers, useUserDetail, useUserPermissions } from "../../services/hooks";
import { useAddRuleDetailMutation, useDeleteRuleDetailMutation, useUpdateRuleDetailMutation } from "../../api/vmsSlice";
import { assignDeep } from "../Dynamic/DynamicForm";
import { Grid } from "@mui/material";
import { capitalizeCamelCase, debounce } from "../../services/functions";
import { Navigate } from "react-router-dom";
import { usePlantContext } from "../../context/plantContext";

const defaultFilter = {
    pagesize: 10,
    page_no: 1,
    ruleType: "validation"
};
const RouteValidation = () => {
    const [displayForm, setDisplayForm] = useState(false);
    const { userPermissions, isFetched } = useUserPermissions();
    const [selectedPlant, setSelectedPlant] = useState(null);
    const { plants, plantOptions, getPlantDetails } = usePlant();
    const { userDetail } = useUserDetail();
    const filterRef = useRef(defaultFilter);
    const { page_no = 1, pagesize = 10 } = filterRef.current;
    const {plantId} = usePlantContext()
    const { rules, count, isLoading, getRuleDetails } = useRule({...filterRef.current, plantIds: selectedPlant || plantId});
    const updateDataRef = useRef(null);
    const [handleDelete] = useDeleteRuleDetailMutation();
     useEffect(() => {
        if (userDetail?.orgId) {
            getPlantDetails({ orgId: userDetail.orgId });
        }
    }, [userDetail?.orgId]);
    useEffect(() => {
        if (plantId && selectedPlant === null) {
            setSelectedPlant(plantId);
            getRuleDetails({ ...filterRef.current, plantIds: plantId });
        }
    }, [plantId]);
    const handlePlantChange = (option) => {
        setSelectedPlant(option?.value || null);
        getRuleDetails({...filterRef.current, plantIds: option?.value|| plantId})
    };
    const handleFormOpen = () => {
        if (!selectedPlant) {
            toastMessage(false, "Please select a Plant before adding a validation.");
            return;
        }
        if (displayForm) {
            // Clear the updateDataRef when closing the form
            updateDataRef.current = null;
        }
        setDisplayForm(!displayForm);
    };

    let actionHandlers = {};
    // if (userPermissions?.updateRule?.value) {
        actionHandlers.edit = (id) => {
            updateDataRef.current = rules[id];
            setDisplayForm(true);
        };
    // }

    // if (userPermissions?.deleteRule?.value) {
        actionHandlers.delete = async (id) => {
            // console.log(id, "delete");
            const data = rules[id];
            const payload = { id: data._id };
            const {
                data: { error, message },
            } = await handleDelete(payload);
            if (error) {
                toastMessage(false, message);
            } else {
                onUpdateSuccess();
                toastMessage(true, message);
            }
        };
    // }

    let header = ["S.no", "Name", "Start Checkpoint", "Start Checkpoint Time", "End Checkpoint",];
    if (userDetail?.userType == "superAdmin") {
        header.splice(2, 0, "Org Name");
    }
    // if (userPermissions?.updateRule?.value || userPermissions?.deleteRule?.value) {
        header.push("Action");
    // }

    const rows =
        rules?.map((d, i) => {
            let row = [];
            row.push(
                tCell((page_no - 1) * pagesize + i + 1),
                tCell(d.name),
                tCell(d.startCheckpoint.name),
                tCell(capitalizeCamelCase(d.startCheckpointTime)),
                tCell(d.endCheckpoint.name),
                // tCell(capitalizeCamelCase(d.endCheckpointTime))
            );
            if (userDetail?.userType == "superAdmin") {
                row.splice(2, 0, tCell(d.orgName));
            }
            // if (userPermissions?.updateRule?.value || userPermissions?.deleteRule?.value) {
                row.push(
                    <div style={{ paddingLeft: "0.5rem" }}>
                        <ActionMenu id={i} handlers={actionHandlers} />
                    </div>
                );
            // }
            return row;
        }) || [];

    const onPageChange = (page_no) => {
        filterRef.current = { ...filterRef.current, page_no: page_no + 1 };
        getRuleDetails({...filterRef.current, plantIds: selectedPlant || plantId});
    };

    const onPageSizeChange = (e) => {
        const { value } = e.target;
        filterRef.current = { ...filterRef.current, pagesize: value };
        getRuleDetails({...filterRef.current, plantIds: selectedPlant || plantId});
    };

    const onUpdateSuccess = () => {
        getRuleDetails({...filterRef.current, plantIds: selectedPlant || plantId});
        setDisplayForm(false);
    };

    const getTitle = () => {
        if (!displayForm) return "Route Validation";
        return updateDataRef.current ? "Update Route Validation" : "Add Route Validation";
    };
    if (isFetched && userPermissions && Object.keys(userPermissions).length && !userPermissions?.manageRouteValidations?.value) return <Navigate to="/not-authorized" replace />;
    if (window.location.pathname !== "/settings") {
        if (userDetail?.userType !== "superAdmin") return <Navigate to="/not-authorized" replace />;
    }
    return (
        <>
            {!displayForm && (
            <div className="cust-col-3 mt-4">
                <Dropdown
                id="plant"
                name="plant"
                label="Select Warehouse to add route validation"
                options={plantOptions || []}
                value={plantOptions?.find((p) => p.value === selectedPlant) || null}
                onChange={handlePlantChange}
                required
                />
            </div>
            )}
            <div className="cust-row flex-algn-cent">
                <div className="cust-col-5">
                    <h1 className="title">{getTitle()}</h1>
                </div>
                <div className="cust-col-5 flex-jc-end">
                    <Button onClick={handleFormOpen} text={displayForm ? "Go Back" : "Add Validation"} style={{ ...buttonClasses.lynkitOrangeEmpty, width: "20%" }} />
                </div>
            </div>
            <hr className="bgg" />

            {displayForm ? (
                <AddRuleManagement updateData={updateDataRef?.current} onUpdateSuccess={onUpdateSuccess} selectedPlant={selectedPlant}  plantId={plantId}/>
            ) : (
                <div className="main_content">
                    <GenericTable
                        header={header}
                        rows={rows}
                        pageCount={count}
                        pageNo={page_no}
                        limit={filterRef.current?.pagesize}
                        onPageChange={onPageChange}
                        onPageSizeChange={onPageSizeChange}
                        isLoading={isLoading}
                    />
                </div>
            )}
        </>
    );
};
export default RouteValidation;

const defaultForm = {
    name: "", // rule name
    startCheckpoint: {
        id: "", // _id
        name: "", // checkpoint name
    },
    startCheckpointTime: "", // in || out
    endCheckpoint: {
        id: "", // _id
        name: "", // checkpoint name
    },
    // endCheckpointTime: "", // in || out
    item: {
        id: "", // _id
        name: "", // item name
        module: "", // module name - only for dynamic module type
    },
    type: "", // product category, product, supplier or "dynamicModule" when a dynamic module is selected
    // condition: "", // >= | <=
    duration: {
        value: "", // number
        type: "", // second, minute, hour, day
    },
    orgId: "",
    message:"",
};

function fillUpdateData(data) {
    // VEHICLE CATEGORY CASE FOR STRING IN ITEM
    if (data.type === "vehicleCategory") {
        return {
            name: data.name,
            startCheckpoint: { id: data.startCheckpoint.id, name: data.startCheckpoint.name },
            startCheckpointTime: data.startCheckpointTime,
            endCheckpoint: { id: data.endCheckpoint.id, name: data.endCheckpoint.name },
            // endCheckpointTime: data.endCheckpointTime,
            type: "vehicleCategory",
            item: data.item || "",

            duration: { value: data.duration.value, type: data.duration.type },
            orgId: data.orgId,
            message: data.message,
        };
    }

    // DEFAULT CASE FOR OBJECT IN ITEM 
    return {
        name: data.name,
        startCheckpoint: { id: data.startCheckpoint.id, name: data.startCheckpoint.name },
        startCheckpointTime: data.startCheckpointTime,
        endCheckpoint: { id: data.endCheckpoint.id, name: data.endCheckpoint.name },
        // endCheckpointTime: data.endCheckpointTime,
        type: data.type !== "dynamicModule" ? data.type : data.item?.module,
        item: {
            id: data?.item?.id ?? "",
            name: data.item?.name,
            ...(data.type === "dynamicModule" && { module: data.item?.module }),
        },
        duration: { value: data.duration.value, type: data.duration.type },
        orgId: data.orgId,
        message: data?.message,
    };
}

const durationTypeOption = [
    { label: "Seconds", value: "seconds" },
    { label: "Minutes", value: "minutes" },
    { label: "Hours", value: "hours" },
    { label: "Days", value: "days" },
];

const defaultFilterAddRule = {
    pagesize: 100,
    page_no: 1,
};
const timeOpts = [
    { label: "In Time", value: "inTime" },
    { label: "Out Time", value: "outTime" },
];
const vehicleCategoryOptions =[
    {label: "Commercial", value: "COMMERCIAL"},
    {label: "Private", value: "PRIVATE"},

]
function AddRuleManagement({ updateData, onUpdateSuccess, selectedPlant, plantId  }) {
    const [formData, setFormData] = useState(updateData ? fillUpdateData(updateData) : defaultForm);
    const [errors, setErrors] = useState({});

    const [itemType, setItemType] = useState([]);
    const filterRef = useRef(defaultFilterAddRule);
    const { page_no = 1, pagesize = 20 } = filterRef.current;
    const { plants, plantOptions, getPlantDetails } = usePlant();
    const { checkpoints, checkpointOptions, getCheckpoints, clearCheckpointData } = useCheckpoints();
    const { userDetail } = useUserDetail();
    const { productCategories, message, getProdCats } = useProductCategories(filterRef.current);
    const { products, count: productCount, getProducts } = useProducts(filterRef.current);
    const { suppliers, count: supplierCount, getSuppliers } = useSuppliers(filterRef.current);
    const { dynamicModules, getDynamicModules } = useDynamicModules(filterRef.current);
    const { dynamicModuleEntries, count, isLoading, getDynamicModuleEntries, tableHeader } = useDynamicModuleEntries();

    const dynamicModuleOptions = dynamicModules ? dynamicModules?.map((ele) => ({ label: ele.moduleName, value: ele.moduleName })) : [];
    const dynamicModuleOptionsWithTempId = dynamicModules ? dynamicModules?.map((ele) => ({ label: ele.moduleName, value: ele.moduleName, templateId: ele.templateId })) : [];
    const templateIdArray = dynamicModuleOptionsWithTempId.find((ele) => ele.value === formData.type);
    const templateId = templateIdArray?.templateId;
    let orgId = userDetail?.orgId;
    const moduleName = templateIdArray?.label;

    const { orgOptions } = useOrgs();
    const orgValue = orgOptions.find((_) => _.value == formData.orgId) || null;
    // console.log('orgValue', orgValue)

    if (userDetail?.userType === "superAdmin") {
        orgId = orgValue?.value;
    }
    // console.log("SELECTED PLANTS", selectedPlant, { ...filterRef.current, plantIds: selectedPlant }, checkpointOptions)
    useEffect(() => {
        if (!selectedPlant) return;
        if (selectedPlant) {
            getCheckpoints({
                page_no: filterRef.current.page_no,
                pagesize: filterRef.current.pagesize,
                plantIds: selectedPlant,
                orgId: formData.orgId,
            });
        }
    }, [selectedPlant]);
    
    useEffect(() => {
        const entriesPayload = { ...filterRef.current, templateId, orgId, moduleName };
        if (templateId && orgId && moduleName) {
            getDynamicModuleEntries(entriesPayload);
        }
    }, [templateId, orgId, moduleName]);

    useEffect(() => {
        // console.log("call");
        if (!formData.type) {
            // setItemType([]);
            return;
        }
        let newItems = [];
        switch (formData.type) {
            case "supplier":
                newItems = suppliers?.map((ele) => ({ label: ele.supplierName, value: ele._id })) || [];
                break;
            case "product":
                newItems = products?.map((ele) => ({ label: ele.productName, value: ele._id })) || [];
                break;
            case "productCategory":
                newItems = productCategories?.map((ele) => ({ label: ele.productCategory, value: ele._id })) || [];
                break;
            case "vehicleCategory":
                newItems = vehicleCategoryOptions
                break;
            default: {
                const selectedDynamicModule = dynamicModules.find((module) => module.moduleName === formData.type);
                if (selectedDynamicModule && dynamicModuleEntries.length) {
                    const { bindingKey, bindingValue } = selectedDynamicModule;
                    newItems = dynamicModuleEntries.map((entry) => ({
                        label: entry[bindingKey] || entry[bindingValue],
                        value: entry[bindingValue],
                    }));
                }
                break;
            }
        }
        setItemType((prev) => (JSON.stringify(prev) !== JSON.stringify(newItems) ? newItems : prev));
    }, [formData.type, suppliers, products, productCategories, dynamicModules, dynamicModuleEntries]);
    const checkpointPayload = useMemo(() => {
        return {
            page_no: filterRef.current.page_no,
            pagesize: filterRef.current.pagesize,
            orgId: formData.orgId,
            plantIds: selectedPlant
        };
    }, [formData.orgId, selectedPlant]);
    useEffect(() => {
        getCheckpoints(checkpointPayload);
        getDynamicModules({ ...filterRef.current, orgId: formData.orgId });
        getProducts({ ...filterRef.current, orgId: formData.orgId, plantIds: selectedPlant });
        getProdCats({ ...filterRef.current, orgId: formData.orgId, plantIds: selectedPlant });
        getSuppliers({ ...filterRef.current, orgId: formData.orgId, plantIds: selectedPlant });
    }, [formData.orgId]);

    // DROPDOWN OPTION RENDERING
    const handleDropdownSearch = useCallback(
        debounce((value, plantId, orgId) => {
            if (!value || value.trim() === "") return;
            getCheckpoints({ search: value, plantIds: plantId, orgId: orgId });
        }, 500),
        []
    );

    const itemTypeOptions = [{ label: "Product", value: "product" }, { label: "Product Category", value: "productCategory" }, { label: "Supplier", value: "supplier" },{ label: "Vehicle Category", value: "vehicleCategory" }, ...dynamicModuleOptions];

    const [handleSubmit] = useAddRuleDetailMutation();
    const [handleUpdate] = useUpdateRuleDetailMutation();

    const handleInput = (e) => {
        const { name, value } = e.target;
        setFormData((old) => {
            let newData = { ...old };
            assignDeep(newData, name, value);
            return newData;
        });
    };

    const disableCheckpointTimeRef = useRef(false);
    const onDropdownChange = (option, name) => {
        let value = Array.isArray(option) ? option.map((_) => _.value) : option?.value || "";

        if (name == "startCheckpoint" || name == "endCheckpoint") {
            if ((name == "startCheckpoint" && value == formData.endCheckpoint.id) || (name == "endCheckpoint" && value == formData.startCheckpoint.id)) {
                // setFormData((o) => ({ ...o, startCheckpointTime: "inTime", endCheckpointTime: "outTime" }));
                disableCheckpointTimeRef.current = true;
            } else {
                disableCheckpointTimeRef.current = false;
            }
            setFormData((o) => ({
                ...o,
                [name]: {
                    id: value,
                    name: option?.label || "",
                },
            }));
        } else if (name === "item") {
                if (formData.type === "vehicleCategory") {
                    setFormData({
                        ...formData,
                        item: option?.value || "", //  ONLY STRING
                    });
                    return;
                }
            setFormData({
                ...formData,
                item: {
                    id: option?.value,
                    name: option?.label || "",
                    // Include module only if it exists
                    ...(formData.type !== "supplier" && formData.type !== "product" && formData.type !== "productCategory" && { module: formData.type }),
                },
            });
        } else if (name === "duration.type") {
            setFormData((old) => {
                let newForm = { ...old };
                assignDeep(newForm, name, value);
                return newForm;
            });
        } else if (name === "orgId") {
            setFormData({ ...formData, [name]: value });
            // getCheckpoints({...filterRef.current, orgId:value})
            getDynamicModules({ ...filterRef.current, orgId: value });
            getProducts({ ...filterRef.current, orgId: value, plantIds: selectedPlant });
            getProdCats({ ...filterRef.current, orgId: value, plantIds: selectedPlant });
            getSuppliers({ ...filterRef.current, orgId: value, plantIds: selectedPlant });
        } else if (name === "type") {
            if (!option) {
                setFormData((prev) => ({
                    ...prev,
                    item: { id: "", name: "" },
                    type: "",
                }));
                setItemType([]);
                filterRef.current = {
                    page_no: "1",
                    pagesize: "20",
                    search: "",
                };
                // console.log('formData', option, formData)
            } else {
                setFormData({ ...formData, [name]: value });
                filterRef.current = {
                    page_no: "1",
                    pagesize: "20",
                    search: "",
                };
            }
        } else {
            setFormData({ ...formData, [name]: value });
        }
    };

    const handleClose = () => {
        setFormData(defaultForm);
        setErrors({});
    };

    const handleFormSubmit = async () => {
        const { valid, errors } = validateForm(formData);
        const selectedPlantObj = plantOptions?.find(p => p.value === selectedPlant);
        const plantName = selectedPlantObj?.label || "";
        console.log("plantName", plantName)
        if (valid) {
            setErrors({});
            let payload = { ...formData, plantId: selectedPlant, condition: ">=", ruleType: "validation", plantName, endCheckpointTime: "inTime" };
            if (userDetail?.userType === "superAdmin") {
                payload.orgName = orgValue?.label;
            }
            if (formData.type && !["supplier", "product", "productCategory", "vehicleCategory"].includes(formData.type)) {
                payload.type = "dynamicModule";
            }
            // console.log("payload", payload );
            let updatePayload = {
                id: updateData?._id,
                updateData: {
                    ...formData,
                },
            };
            const {
                data: { error, message },
            } = updateData ? await handleUpdate(updatePayload) : await handleSubmit(payload);
            if (error) {
                toastMessage(false, message);
            } else {
                toastMessage(true, message);
                onUpdateSuccess();
                handleClose();
            }
        } else {
            setErrors(errors);
            return;
        }
    };

    function validateForm(formData) {
        let errors = {};
        let valid = true;

        // Validate Name
        if (!formData.name.trim()) {
            errors.name = "Name is required";
            valid = false;
        }
        if (userDetail?.userType == "superAdmin" && !formData?.orgId) {
            errors.orgId = "Organization name is required";
            valid = false;
        }
        // Validate start checkpoint
        if (!formData.startCheckpoint.id) {
            errors.startCheckpoint = "Start checkpoint is required";
            valid = false;
        }
        if (!formData.startCheckpointTime) {
            errors.startCheckpointTime = "Start checkpoint time is required";
            valid = false;
        }
        // Validate end checkpoint
        if (!formData.endCheckpoint.id) {
            errors.endCheckpoint = "End checkpoint time is required";
            valid = false;
        }
        // if (!formData.endCheckpointTime) {
        //     errors.endCheckpointTime = "End checkpoint time is required";
        //     valid = false;
        // }
        // Validate condition
        // if (!formData.condition) {
        //     errors.condition = "Condition is required";
        //     valid = false;
        // }
        errors.duration = {};
        //Validate duration
        if (!formData.duration.value) {
            errors.duration.value = "Time duration is required";
            valid = false;
        }

        if (formData.duration.value < 0) {
            errors.duration.value = "Time duration can't be negative";
            valid = false;
        }

        if (formData.duration.value > 500) {
            errors.duration.value = "Time duration should be within 500";
            valid = false;
        }
        // validate duration type
        if (!formData.duration.type) {
            errors.duration.type = "Duration type is required";
            valid = false;
        }

        return { errors, valid };
    }
    // console.log(formData);
    return (
        <>
            <form className="form-inputs">
                {userDetail?.userType == "superAdmin" ? (
                    <Dropdown id="orgId" name="orgId" label="Organization Name" onChange={onDropdownChange} options={orgOptions} value={orgValue} error={errors?.orgId} required />
                ) : null}
                <Input label="Name" placeholder="Enter Name" name="name" value={formData.name} onChange={handleInput} required error={errors?.name} />
                <Dropdown
                    id="startCheckpoint"
                    name="startCheckpoint"
                    value={checkpointOptions.find((_) => _.value == formData.startCheckpoint?.id) || null}
                    options={userDetail?.userType === "superAdmin" && !formData.orgId ? [] : checkpointOptions}
                    label="Start Checkpoint"
                    onChange={onDropdownChange}
                    onInputChange={({ target: { value } }) => {
                        handleDropdownSearch(value, selectedPlant, formData.orgId);
                    }}
                    required
                    error={errors?.startCheckpoint}
                />
                <Dropdown
                    id="startCheckpointTime"
                    name="startCheckpointTime"
                    value={timeOpts.find((_) => _.value == formData.startCheckpointTime) || null}
                    options={timeOpts}
                    label="Start Checkpoint Time"
                    onChange={onDropdownChange}
                    required
                    error={errors?.startCheckpointTime}
                    disabled={disableCheckpointTimeRef.current}
                />
                <Dropdown
                    id="endCheckpoint"
                    name="endCheckpoint"
                    value={checkpointOptions.find((_) => _.value == formData.endCheckpoint?.id) || null}
                    options={userDetail?.userType === "superAdmin" && !formData.orgId ? [] : checkpointOptions}
                    label="End Checkpoint"
                    onChange={onDropdownChange}
                    onInputChange={({ target: { value } }) => {
                        handleDropdownSearch(value, selectedPlant, formData.orgId);
                    }}
                    required
                    error={errors?.endCheckpoint}
                />
                {/* <Dropdown
                    id="endCheckpointTime"
                    name="endCheckpointTime"
                    value={timeOpts.find((_) => _.value == formData.endCheckpointTime) || null}
                    options={timeOpts}
                    label="End Checkpoint Time"
                    onChange={onDropdownChange}
                    required
                    error={errors?.endCheckpointTime}
                    disabled={disableCheckpointTimeRef.current}
                /> */}
                {/* <Dropdown
                    id="condition"
                    name="condition"
                    value={conditionOption.find((_) => _.value == formData.condition) || null}
                    options={conditionOption}
                    label="Condition"
                    onChange={onDropdownChange}
                    required
                    error={errors?.condition}
                /> */}

                <Dropdown
                    id="durationType"
                    name="duration.type"
                    value={durationTypeOption.find((_) => _.value == formData.duration?.type) || null}
                    options={durationTypeOption}
                    label="Duration Type"
                    required
                    onChange={onDropdownChange}
                    error={errors?.duration?.type}
                />
                <Input id="duration" name="duration.value" value={formData?.duration?.value || null} type="number" label="Duration" onChange={handleInput} error={errors?.duration?.value} required />

                <Dropdown
                    id="type"
                    name="type"
                    value={itemTypeOptions.find((_) => _.value == formData.type) || null}
                    options={itemTypeOptions}
                    label="Item Type"
                    onChange={onDropdownChange}
                    error={errors?.type}
                />
                <Dropdown
                    id="item"
                    name="item"
                    value={ formData.type === "vehicleCategory"
                        ? itemType.find((ele) => ele.value === formData.item) // string match
                        : itemType.find((ele) => ele.value === formData.item.id)}
                    options={itemType || []}
                    label="Item"
                    onChange={onDropdownChange}
                    error={errors?.item}
                />
                <Input label="Message" placeholder="Enter Message" name="message" value={formData.message} onChange={handleInput} />
            </form>
            <Grid container justifyContent="center" marginTop={1}>
                <Grid container justifyContent="center" item xs={8} sm={6} md={4}>
                    <Button text={updateData ? "Update" : "Submit"} style={{ ...buttonClasses.lynkitOrangeFill, width: "28%" }} onClick={handleFormSubmit} />
                </Grid>
            </Grid>
        </>
    );
}
